<script>
    import router from "page";

    import Dropdown from "../components/Dropdown.svelte";

    import {
        isAuthenticated,
        isAdmin,
        activePage,
        client,
        locale,
    } from "../stores.js";

    import { getLocaleResource } from "../utils/locales.js";

    let showDropdown;

    function toggleDropdown() {
        showDropdown = !showDropdown;
    }

    function logout() {
        localStorage.removeItem("token");
        $isAuthenticated = false;
        router("/login");
    }
</script>

<Dropdown
    options={{
        hover: true,
        dropdownStyle: "max-width: 200px; right: 10px;",
    }}
>
    <i
        slot="toggle"
        class="menu-toggle fas fa-user-circle"
        on:click={toggleDropdown}
    />

    <a href="/user">
        <div class="menu-item" class:active={$activePage == "user"}>
            <span>
                {$client.companyKey}
                {$client.companyName ? `- ${$client.companyName}` : ""} -
                <span style="opacity: 0.3;">{$client.email}</span>
            </span>
        </div>
    </a>

    <hr />

    <a href="/sale">
        <div class="menu-item">
            {getLocaleResource($locale, "onSale")}
        </div>
    </a>

    <a href="/new">
        <div class="menu-item">
            {getLocaleResource($locale, "newProducts")}
        </div>
    </a>

    <hr />

    <a href="/carts">
        <div class="menu-item">
            {getLocaleResource($locale, "carts")}
        </div>
    </a>

    <a href="/orders">
        <div class="menu-item">
            {getLocaleResource($locale, "orders")}
        </div>
    </a>

    <a href="/invoices">
        <div class="menu-item">
            {getLocaleResource($locale, "invoices")}
        </div>
    </a>

    <a href="/finance">
        <div class="menu-item">
            {getLocaleResource($locale, "finance")}
        </div>
    </a>

    <hr />

    <div on:click={logout} class="menu-item logout" class:right={$isAdmin}>
        <i class="fas fa-power-off" />
        {getLocaleResource($locale, "logout")}
    </div>
</Dropdown>

<style>
    .menu-toggle {
        font-size: 30px;
        color: #999;
        cursor: pointer;
    }

    .menu-item {
        border-radius: 3px;
        color: black;
        display: flex;
        align-items: center;
    }

    .menu-item i {
        margin-right: 10px;
        width: 20px;
        opacity: 0.3;
        text-align: center;
    }

    hr {
        border: 0;
        height: 1px;
        background: rgba(0, 0, 0, 0.1);
    }

    .logout {
        color: red;
        cursor: pointer;
    }
</style>
